import React, {useEffect, useRef, useState} from "react";
import clsx from "clsx";
import {AddPositionProps, schema} from "./components.utils";
import {useForm, useWatch} from "react-hook-form";
import {joiResolver} from "@hookform/resolvers/joi";
import FullscreenModal from "../../../../components/FullscreenModal";
import {FormMaterialInput} from "../../../../components/Inputs/MaterialInput";
import {FormMaterialSelector} from "../../../../components/Selector";
import {MenuItem} from "@material-ui/core";
import {FormCheckboxInput} from "../../../../components/Inputs/CheckboxInput";
import styles from "./components.module.scss";
import {FormMaterialCalendarPicker} from "../../../../components/Inputs/MaterialCalendarPicker";
import dayjs from "dayjs";

// @ts-ignore
const TempStars: any = window.TempStars;

export const AddPosition = ({country, onAdd, isOpen, onClose, position}: AddPositionProps) => {
    const {
        control,
        handleSubmit,
        setValue,
        watch
    } = useForm({
        defaultValues: {
            jobTitle: position?.jobTitle || '',
            companyName: position?.companyName || '',
            city: position?.city || '',
            employmentType: position?.employmentType || '',
            current: !!position?.current || false,
            fromDate: position?.fromDate || dayjs().set("day", 1),
            toDate: position?.toDate || dayjs().set("day", 1),
        },
        resolver: joiResolver(schema) as any,
    });
    const [inputValue, setInputValue] = useState(position?.city || '');
    const autocompleteRef = useRef<any>(null);
  
    useEffect(() => {
        let autocompleteInstance: any;
      
        const initAutocomplete = () => {
          const input = document.getElementById('autocomplete') as HTMLInputElement;
          if (input) {
            autocompleteInstance = TempStars.Autocomplete.init(
              {
                country: country,
                types: ['(cities)']
              },
              (place: { city?: string, valueEqual?: boolean }) => {
                if (place && place.city) {
                  setInputValue(place.city);
                  setValue('city', place.city, { shouldValidate: true });
                }
              }
            );
      
            input.addEventListener('input', (event) => {
              const newValue = (event.target as HTMLInputElement).value;
              setInputValue(newValue);
              setValue('city', newValue, { shouldValidate: false });
            });
          }
      
          return () => {
            if (autocompleteInstance) {
              TempStars.Autocomplete.removeListener();
            }
            if (input) {
              input.removeEventListener('input', () => {});
            }
          };
        };
      
        return initAutocomplete();
      }, [country, setValue]);

    const current = useWatch({control, name: "current"})
    if(current) {
        setValue('toDate', dayjs())
    }

    return (
        <FullscreenModal
            title={'Work Experience'}
            isOpen={isOpen}
            buttonText={'Save'}
            onClose={onClose}
            onSubmit={handleSubmit(onAdd as any)}
            isSignUpPage={true}
            >
            <div className="list-block inset inputBox">
                <FormMaterialInput
                    control={control}
                    className={'styledInput'}
                    label="Job Title"
                    name={"jobTitle"}
                />
            </div>
            <div className="list-block inset inputBox">

                <FormMaterialInput
                    control={control}
                    className={'styledInput'}
                    label="Company Name"
                    name={"companyName"}
                />
            </div>
            <div className="list-block inset inputBox">
                <FormMaterialInput
                    control={control}
                    name="city"
                    label="Start typing a city name..."
                    id="autocomplete"
                    className={'no-fastclick'}
                    inputProps={{
                        value: inputValue,
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                        const newValue = e.target.value;
                        setInputValue(newValue);
                        },
                    }}
                />
            </div>
            <div className="list-block inset inputBox">
                <FormMaterialSelector
                    control={control}
                    className={'styledInput'}
                    label="Employment Type"
                    name={"employmentType"}
                >
                    <MenuItem
                        key={'fulltime'}
                        value={'fulltime'}
                    >
                        Full-time
                    </MenuItem>
                    <MenuItem
                        key={'parttime'}
                        value={'parttime'}
                    >
                        Part-time
                    </MenuItem>
                    <MenuItem
                        key={'contract'}
                        value={'contract'}
                    >
                        Contract
                    </MenuItem>
                </FormMaterialSelector>
            </div>
            <div className="list-block inset inputBox">
                <FormCheckboxInput
                    control={control}
                    className={'styledInput'}
                    label="I am currently working in this role"
                    name={"current"}
                />
            </div>
            <div className={clsx("list-block inset inputBox", styles.datePickers)}>
                <FormMaterialCalendarPicker
                    control={control}
                    name={'fromDate'}
                    label={'From'}
                    format={'MMM YYYY'}
                    views={['month', 'year']}
                />
                <FormMaterialCalendarPicker
                    control={control}
                    name={'toDate'}
                    label={'To'}
                    format={'MMM YYYY'}
                    views={['month', 'year']}
                    disabled={current}
                />
            </div>
        </FullscreenModal>
    )
}